import { guardTrainingsModuleAddon } from '@/ui/routes/guards/guardTrainingsModuleAddon';
import { NamedRouteConfig } from './types';
// eslint-disable-next-line max-len
import { ChecklistChooseTemplatePage } from '@/ui/pages/checklist/checklistChooseTemplatePage/ChecklistChooseTemplatePage';
import { t } from '@/ui/i18n/i18n';
import { guardAuthenticatedRoutes } from '@/ui/routes/guards';
import { InspectionCreatePage } from '@/ui/pages/inspection/InspectionCreatePage';
import { InspectionEditPage } from '@/ui/pages/inspection/InspectionEditPage';
import { ChecklistCreatePage } from '@/ui/pages/checklist/ChecklistCreatePage';
import { parseIdFromRoute } from '@/ui/routes/authenticatedRoutes';
import { ChecklistEditPage } from '@/ui/pages/checklist/ChecklistEditPage';
import AnalyticsBuilder from '@/ui/pages/analytics/Builder/AnalyticsBuilder.vue';
import { guardAnalyticsFeatureToggle } from '@/ui/routes/guards/guardAnalyticsFeatureToggle';
import { multiguard } from '@/ui/routes/guards/multiguard';
import { guardAiTemplateFeatureToggle } from '@/ui/routes/guards/guardAiTemplateFeatureToggle';
import CreateChecklistChooseMethodPage from '@/ui/pages/checklist/CreateChecklistChooseMethodPage.vue';
import CreateChecklistFileUploadPage from '@/ui/pages/checklist/CreateChecklistFileUploadPage.vue';
import CreateChecklistAiPromptPage from '@/ui/pages/checklist/CreateChecklistAiPromptPage.vue';
import AnalyticsAiChatPage from '@/ui/pages/analytics/AiChat/AnalyticsAiChatPage.vue';
import CourseBuilderPage from '@/ui/pages/trainings/CourseBuilderPage.vue';
import CourseTakePage from '@/ui/pages/trainings/CourseTakePage.vue';

const analyticsPath = 'analytics-v2';

export const noNavbarRoutes: NamedRouteConfig[] = [
  {
    path: '/checklists/templates',
    name: 'checklistChooseTemplate',
    component: ChecklistChooseTemplatePage,
    beforeEnter: guardAuthenticatedRoutes,
    meta: {
      title: t('common.templates'),
    },
  },
  {
    path: '/courses/:id',
    name: 'courseBuilder',
    component: CourseBuilderPage,
    props: parseIdFromRoute,
    beforeEnter: multiguard([guardAuthenticatedRoutes, guardTrainingsModuleAddon]),
    meta: {
      disablePadding: true,
    },
  },
  {
    path: '/course-take/:id',
    name: 'courseTake',
    component: CourseTakePage,
    props: parseIdFromRoute,
    beforeEnter: multiguard([guardAuthenticatedRoutes, guardTrainingsModuleAddon]),
    meta: {
      disablePadding: true,
    },
  },
  {
    path: '/checklists/choose-method',
    name: 'checklistChooseMethod',
    component: CreateChecklistChooseMethodPage,
    props: parseIdFromRoute,
    beforeEnter: multiguard([guardAiTemplateFeatureToggle, guardAuthenticatedRoutes]),
    meta: {
      title: t('common.templates'),
      disablePadding: true,
    },
  },
  {
    path: '/checklists/file-upload',
    name: 'checklistFileUpload',
    component: CreateChecklistFileUploadPage,
    props: parseIdFromRoute,
    beforeEnter: multiguard([guardAiTemplateFeatureToggle, guardAuthenticatedRoutes]),
    meta: {
      title: t('common.templates'),
      disablePadding: true,
    },
  },
  {
    path: '/checklists/ai-prompt',
    name: 'checklistAiPrompt',
    component: CreateChecklistAiPromptPage,
    props: parseIdFromRoute,
    beforeEnter: multiguard([guardAiTemplateFeatureToggle, guardAuthenticatedRoutes]),
    meta: {
      title: t('common.templates'),
      disablePadding: true,
    },
  },
  {
    path: '/checklists/new',
    name: 'checklistCreate',
    component: ChecklistCreatePage,
    props: parseIdFromRoute,
    beforeEnter: guardAuthenticatedRoutes,
    meta: {
      title: t('common.templates'),
      disablePadding: true,
    },
  },
  {
    path: '/checklists/:id',
    name: 'checklistEdit',
    component: ChecklistEditPage,
    props: parseIdFromRoute,
    beforeEnter: guardAuthenticatedRoutes,
    meta: {
      title: t('common.templates'),
      disablePadding: true,
    },
  },
  {
    path: '/inspections/new/:id',
    name: 'inspectionCreate',
    component: InspectionCreatePage,
    props: parseIdFromRoute,
    beforeEnter: guardAuthenticatedRoutes,
    meta: {
      title: t('common.inspections'),
      disablePadding: true,
    },
  },
  {
    path: '/inspections/:id/edit',
    name: 'inspectionEdit',
    component: InspectionEditPage,
    props: parseIdFromRoute,
    meta: {
      title: t('common.inspections'),
      disablePadding: true,
    },
  },
  {
    path: `/${analyticsPath}/report`,
    name: 'analyticsReportCreate',
    component: AnalyticsBuilder,
    beforeEnter: multiguard([guardAnalyticsFeatureToggle, guardAuthenticatedRoutes]),
    meta: {
      title: t('common.analytics'),
      disablePadding: true,
    },
  },
  {
    path: `/${analyticsPath}/report/:id`,
    name: 'analyticsReportEdit',
    component: AnalyticsBuilder,
    beforeEnter: guardAnalyticsFeatureToggle,
    props: parseIdFromRoute,
    meta: {
      title: t('common.analytics'),
      disablePadding: true,
    },
  },
  {
    path: '/ai',
    name: 'analyticsAiChat',
    component: AnalyticsAiChatPage,
    beforeEnter: multiguard([guardAnalyticsFeatureToggle, guardAuthenticatedRoutes]),
    meta: {
      title: t('common.analytics'),
      disablePadding: true,
    },
  },
];
